import { Plus } from "react-feather";
import { CircularProgress } from "@mui/material";
import styles from "../../communication-chat.module.css";
import { useAuth0 } from "@auth0/auth0-react";

const EmployeeGroupsUnread = (props) => {
  const items = props.items || [];
  const groups = items.filter((i) => i.type === "Group");
  const directMessages = items.filter((i) => i.type === "Employee");

  const { isAuthenticated, user } = useAuth0();

  const getInitials = (name) => {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return (
      parts[0].charAt(0) + parts[parts.length - 1].charAt(0)
    ).toUpperCase();
  };

  const isSMSChatTeamchatgroupRead = isAuthenticated && user["https://propertydek.com/permissions"].indexOf("smschat-teamchatgroup:read") > -1;
  const isSMSChatTeamchatgroupCreate = isAuthenticated && user["https://propertydek.com/permissions"].indexOf("smschat-teamchatgroup:create") > -1;

  const renderRow = (item) => (
    <div
      key={item.id}
      className={`${styles.CommuListSec}`}
      onClick={(e) => {
        e.stopPropagation();
        props.onSelect(item);
      }}
    >
      {item.type === "Employee" && (
        <div className={`${styles.EmployeeListDeSec}`}>
          <div className={`${styles.EmployeeAvatarSec}`}>
            {item._employee?.avatar ? (
              <img
                src={item._employee.avatar}
                alt=""
                className={`${styles.EmpAvatarImg}`}
              />
            ) : (
              <p className={`${styles.EmpAvatarInitials}`}>
                {getInitials(item.name)}
              </p>
            )}
            <span
              className={`${styles.StatusBadge} ${item._employee?.online ? styles.Online : ""
                }`}
            ></span>
          </div>

          <div className={`${styles.CommuListDeSec}`}>
            <p className={`${styles.ProsTenantList}`}>
              <span>{item.name}</span>
            </p>
            <p className={`${styles.ProsTenantListDe}`}>
              {/* <span>
                {item.type === "Group"
                  ? (() => {
                    const names = item.subtitle
                      ? item.subtitle.split(", ")
                      : [];
                    if (names.length <= 3) return item.subtitle;
                    return `${names.slice(0, 3).join(", ")} +${names.length - 3
                      }`;
                  })()
                  : item.subtitle}
              </span> */}
              <span>{item.subtitle}</span>
            </p>
          </div>
        </div>
      )}

      {item.type === "Group" && (
        <>
          <div className={`${styles.CommuListDeSec}`}>
            <p className={`${styles.ProsTenantList}`}>
              <span>{item.name}</span>
            </p>
            <p className={`${styles.ProsTenantListDe}`}>
              <span>
                {item.type === "Group"
                  ? (() => {
                    const names = item.subtitle
                      ? item.subtitle.split(", ")
                      : [];
                    if (names.length <= 3) return item.subtitle;
                    return `${names.slice(0, 3).join(", ")} +${names.length - 3
                      }`;
                  })()
                  : item.subtitle}
              </span>
            </p>
          </div>

          <div className={`${styles.GroupAvatarSec}`}>
            {item.avatars.slice(0, 3).map((member, idx) => (
              <div key={idx} className={`${styles.GroupAvatar}`}>
                {member.avatar ? (
                  <img
                    src={member.avatar}
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <p
                    className={`${styles.EmpAvatarInitials}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "11px",
                      margin: 0,
                    }}
                  >
                    {getInitials(member.name)}
                  </p>
                )}
              </div>
            ))}
          </div>
        </>
      )}

      {item.unreadCount > 0 && (
        <span className={`${styles.PropertyGroupNotiCount}`}>
          {item.unreadCount}
        </span>
      )}
    </div>
  );

  return (
    <div>
      {isSMSChatTeamchatgroupRead && <>
        <div className={`${styles.TeamSingleTopHead}`}>
          <span>Group Conversations</span>
          {(props.canManageGroups || isSMSChatTeamchatgroupCreate) && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                props.onAddGroup && props.onAddGroup();
              }}
              className={`${styles.AddTeamBU}`}
            >
              <Plus size={10} /> Add Group
            </button>
          )}
        </div>

        {groups.map(renderRow)}
        {groups.length === 0 && (
          <div className={`${styles.NoDataSecOnlyText}`}>
            {props.loading ? (
              <>
                <CircularProgress size={20} sx={{ color: "#502688", mb: "15px" }} />
                <p>Loading group conversations…</p>
              </>
            ) : (
              <>
                <img src="/static/img/chatIcon.png" alt="" />
                <p>No group conversations yet</p>
              </>
            )}
          </div>
        )}

      </>}

      <div className={`${styles.TeamSingleTopHead}`}>Direct Messages</div>

      {directMessages.map(renderRow)}
      {directMessages.length === 0 && (
        <div className={`${styles.NoDataSecOnlyText}`}>
          {props.loading ? (
            <>
              <CircularProgress size={20} sx={{ color: "#502688", mb: "15px" }} />
              <p>Loading direct messages…</p>
            </>
          ) : (
            <>
              <img src="/static/img/chatIcon.png" alt="" />
              <p>No direct messages yet</p>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default EmployeeGroupsUnread;
